/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import { TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const ArrowComponent = ({ component, onClick, className }) => {
  return (
    <div className={`pagination-icon ${className || ''}`} onClick={onClick}>
      {component}
    </div>
  );
};

const CalculatedInterestPagination = ({
  paginationIndex,
  setPaginationIndex,
  maxPages,
}) => {
  const handleNextAndPrevClick = (isNext = true) => {
    const index = paginationIndex + (isNext ? 1 : -1);

    if (parseInt(index) < 1 || parseInt(index) > maxPages) {
      console.error('Page is out of boundary');
    } else {
      setPaginationIndex(parseInt(index));
    }
  };

  const showErrorPopup = (message, maxPages) => {
    console.error('showErrorPopup :', message);
    if (maxPages) setPaginationIndex(maxPages);
  };

  const onTextEnterPress = (e) => {
    if (e.keyCode === 13) {
      if (!paginationIndex) {
        showErrorPopup('Please input a numeric value only');
      } else if (parseInt(paginationIndex) === 0) {
        showErrorPopup('Please input a positive number');
      } else if (parseInt(paginationIndex) > maxPages) {
        showErrorPopup('Please input a number less than total page', maxPages);
      } else {
        setPaginationIndex(parseInt(paginationIndex));
      }
    }
  };

  function generateUniqueId(prefix) {
    return `${prefix}_${Math.random().toString(36).substr(2, 9)}`;
  }

  // Inside your component...
  const uniqueId = generateUniqueId('paginationLabel');

  return (
    <div className='d-flex align-items-center justify-content-end'>
      <ArrowComponent
        className='mr-2'
        component={
          <i className='fa fa-solid fa-angle-left' aria-hidden='true' />
        }
        onClick={() => handleNextAndPrevClick(false)}
      />

      <div className='mui-custom-form with-select pagination-text-field'>
        <label className='m-0 visually-hidden' htmlFor={uniqueId}>
          <span>label</span>{' '}
        </label>
        <TextField
          type='string'
          id={uniqueId}
          value={paginationIndex}
          onKeyDown={onTextEnterPress}
          aria-labelledby={uniqueId}
          style={{ maxWidth: '36px' }}
          onChange={(e) => {
            if (/^[0-9]+$/g.test(e.target.value)) {
              setPaginationIndex(e.target.value);
            } else if (e.target.value === '') {
              setPaginationIndex('');
            }
          }}
          inputProps={{
            id: uniqueId,
            'aria-labelledby': uniqueId,
          }}
        />
      </div>

      <span>{`of ${maxPages}`}</span>
      <ArrowComponent
        className='mt-0 ml-2'
        component={
          <i className='fa fa-solid fa-angle-right' aria-hidden='true' />
        }
        onClick={() => handleNextAndPrevClick()}
      />
    </div>
  );
};

export default CalculatedInterestPagination;
